class ProductModal extends HTMLElement {
  constructor() {
    super();
    this.closeTriggers = this.querySelectorAll('[data-close]');
    this.openTriggers = document.querySelectorAll('[data-trigger="product-modal"]');
		this.productInput = this.querySelector('#product');
    this.dateInput = this.querySelector('#date');
    this.returnDateInput = this.querySelector('#returnDate');
    this.init();
  }

  handleClose() {
    if(!this.closeTriggers?.length) return;

    this.closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        document.querySelector('html').style.overflow = "";
        this.classList.add('closed');
      });
    });
  }

  handleOpen() {
    if(!this.openTriggers?.length) return;



    this.openTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        document.querySelector('html').style.overflow = "hidden";
        e.preventDefault();
        this.classList.remove('closed');
				const productName = trigger.getAttribute('data-product');
        if (this.productInput) {
          this.productInput.value = productName;
        }
      });
    });
  }

  handleReturnDate() {
    if(!this.dateInput || !this.returnDateInput) return;

    this.dateInput.addEventListener('change', () => {
      this.returnDateInput.min = this.dateInput.value;
      if (!this.returnDateInput.value || this.returnDateInput.value < this.dateInput.value) {
        this.returnDateInput.value = this.dateInput.value;
      }
    });
  }

  init() {
    this.handleClose();
    this.handleOpen();
    this.handleReturnDate();
  }
}

if(!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModal);
}
